import * as React from 'react';
const SvgVideo = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 17 12" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.999 5.44v1.11l3 2.109V3.34l-3 2.1zm-2-3.44h-7v8h7V2zm2 7v1.5a1.499 1.499 0 01-1.5 1.5h-8a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5h8a1.498 1.498 0 011.5 1.5V3L15.426.601a1 1 0 011.573.82v9.158a1.001 1.001 0 01-1.573.82L11.999 9z"
            fill="currentColor"
        />
    </svg>
);
export default SvgVideo;
